const LIST_KEY_PREFIX = 'ser_basic_form_list_';
const DETAIL_KEY_PREFIX = 'ser_basic_form_detail_';

const BuildListKey = (custCd) => `${LIST_KEY_PREFIX}${custCd || 'default'}`;

const BuildDetailKey = (custCd, versionId) =>
  `${DETAIL_KEY_PREFIX}${custCd || 'default'}_${versionId}`;

/** API 응답 row → 목록 row 표준화 (GetSerBasicR2) */
export const MapFormListRow = (row = {}) => ({
  versionId: row.versionId ?? row.VersionId ?? '',
  versionNo: row.versionNo ?? row.VersionNo ?? '',
  versionLabel: row.versionLabel ?? row.VersionLabel ?? '',
  versionNm: row.versionNm ?? row.VersionNm ?? '',
  status: row.status ?? row.Status ?? '',
  standardTotalScore:
    row.standardTotalScore ?? row.StandardTotalScore ?? row.totalScore ?? 800,
  calcTotalScore: row.calcTotalScore ?? row.CalcTotalScore ?? 0,
  scoreDiff: row.scoreDiff ?? row.ScoreDiff ?? 0,
  categoryCnt: row.categoryCnt ?? row.CategoryCnt ?? 0,
  indicatorCnt: row.indicatorCnt ?? row.IndicatorCnt ?? 0,
  checkpointCnt: row.checkpointCnt ?? row.CheckpointCnt ?? 0,
  editYn: row.editYn ?? row.EditYn ?? 'N',
  publishYn: row.publishYn ?? row.PublishYn ?? 'N',
  readonlyYn: row.readonlyYn ?? row.ReadonlyYn ?? 'N',
  changeMemo: row.changeMemo ?? row.ChangeMemo ?? '',
  updateDate: row.updateDate ?? row.UpdateDate ?? row.createDate ?? '',
  // 하위 호환
  formCode: String(row.versionId ?? row.VersionId ?? row.formCode ?? ''),
  formVer: String(row.versionNo ?? row.VersionNo ?? row.formVer ?? ''),
  formName: row.versionNm ?? row.VersionNm ?? row.formName ?? '',
  useYn:
    (row.status ?? row.Status) === 'ACTIVE' ||
    (row.status ?? row.Status) === 'DRAFT'
      ? 'Y'
      : 'N',
  remark: row.changeMemo ?? row.ChangeMemo ?? row.remark ?? '',
});

/** GetSerBasicR3 / SaveSerBasicU1 응답 → formData 객체 */
export const ParseFormDataResponse = (row = {}) => {
  if (!row) return null;
  const raw = row.formData ?? row.FormData;
  if (typeof raw === 'object' && raw !== null) return raw;
  if (typeof raw === 'string' && raw.trim()) {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return null;
};

/** 로컬 저장 목록 조회 */
export const LoadLocalFormList = (custCd) => {
  try {
    const raw = localStorage.getItem(BuildListKey(custCd));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(MapFormListRow) : [];
  } catch {
    return [];
  }
};

/** 로컬 목록 저장 */
export const SaveLocalFormList = (custCd, rows) => {
  localStorage.setItem(BuildListKey(custCd), JSON.stringify(rows || []));
};

/** 로컬 양식 상세 조회 */
export const LoadLocalFormDetail = (custCd, versionId) => {
  try {
    const raw = localStorage.getItem(BuildDetailKey(custCd, versionId));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

/** 로컬 양식 상세·목록 동시 저장 */
export const SaveLocalFormDetail = (custCd, payload) => {
  const versionId = payload?.versionId ?? payload?.formCode ?? '';
  if (!versionId) return;

  localStorage.setItem(
    BuildDetailKey(custCd, versionId),
    JSON.stringify(payload)
  );

  const list = LoadLocalFormList(custCd).filter(
    (r) => String(r.versionId) !== String(versionId)
  );
  list.unshift(MapFormListRow(payload));
  SaveLocalFormList(custCd, list);
};

/** ACTIVE(배포) 평가표 1건 선택 — DRAFT 등 폴백 없음 */
export const PickActiveFormRow = (rows = []) => {
  const list = rows.map(MapFormListRow).filter((r) => r.versionId);
  if (!list.length) return null;

  return (
    list.find((r) => String(r.status).toUpperCase() === 'ACTIVE') ?? null
  );
};

/** 배포된 ACTIVE 평가표 존재 여부 */
export const HasActiveFormRow = (rows = []) => Boolean(PickActiveFormRow(rows));

/** @deprecated 로컬 기본 목록 — API 실패 시만 사용 */
export const GetDefaultFormList = () => [];
